<template>
  <svg
    width="256"
    height="256"
    viewBox="0 0 256 256"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M42.8221 167.182H26.6365C21.886 167.182 18.0349 171.033 18.0349 175.783V217.716C18.0349 222.467 21.886 226.318 26.6365 226.318H42.8221C47.5726 226.318 51.4237 222.467 51.4237 217.716V175.783C51.4237 171.033 47.5726 167.182 42.8221 167.182Z"
      class="fill-brand-500"
    />
    <path
      d="M229.587 206.075H227.968V175.79C227.968 171.035 224.115 167.188 219.366 167.188H203.187C198.432 167.188 194.585 171.041 194.585 175.79V206.075H192.966C187.379 206.075 182.841 210.606 182.841 216.199C182.841 221.787 187.372 226.318 192.966 226.318H229.593C235.181 226.318 239.718 221.787 239.718 216.199C239.718 210.612 235.187 206.075 229.593 206.075H229.587Z"
      class="fill-brand-500"
    />
    <path
      d="M241.248 93.3065L226.016 92.3465L221.696 64.7241C219.302 49.4153 206.585 37.8313 191.123 36.8649L73.2476 29.5049C57.7852 28.5385 43.7244 38.4521 39.4428 53.3449L31.7116 80.2313L16.358 79.2585C10.214 78.8681 4.92122 83.5337 4.53082 89.6777L4.49242 90.2665C4.28122 93.5625 6.78362 96.3977 10.0796 96.6089L26.47 97.6457C15.6924 103.438 8.06362 114.491 7.24442 127.598L4.74202 167.873C4.28122 175.297 9.91962 181.684 17.3436 182.151L227.616 195.271C235.04 195.732 241.427 190.094 241.894 182.67L244.409 142.395C245.228 129.281 239.027 117.358 229.043 110.273L245.299 111.303C248.595 111.515 251.43 109.012 251.641 105.716L251.68 105.127C252.07 98.9833 247.404 93.6905 241.26 93.3001L241.248 93.3065Z"
      class="fill-brand-100"
    />
    <path
      d="M184.573 159.099L64.3865 151.369L63.2798 168.575L183.467 176.305L184.573 159.099Z"
      class="fill-secondary-500"
    />
    <path
      d="M57.6686 116.62L29.4154 114.872C25.0726 114.604 21.3342 117.906 21.0655 122.249L20.8411 125.877C20.5724 130.22 23.8752 133.959 28.218 134.227L56.4712 135.975C60.814 136.244 64.5524 132.941 64.821 128.598L65.0455 124.97C65.3141 120.627 62.0114 116.889 57.6686 116.62Z"
      class="fill-brand-500"
    />
    <path
      d="M223.925 126.553L195.748 124.81C191.384 124.54 187.628 127.859 187.358 132.223L187.138 135.774C186.868 140.138 190.187 143.895 194.551 144.165L222.728 145.908C227.092 146.178 230.848 142.859 231.118 138.495L231.338 134.943C231.608 130.579 228.289 126.823 223.925 126.553Z"
      class="fill-brand-500"
    />
    <path
      d="M46.0285 93.3833L210.182 103.63C211.776 103.732 213.331 103.937 214.854 104.231L209.824 72.0713C207.891 59.7257 197.638 50.3817 185.171 49.6073L77.5741 42.8937C65.1005 42.1129 53.7661 50.1129 50.3165 62.1193L41.3245 93.4025C42.8733 93.3001 44.4477 93.2873 46.0349 93.3833H46.0285Z"
      class="fill-brand-500"
    />
  </svg>
</template>

<script>
  export default {
    name: 'BusinessExpense'
  }
</script>
